import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateVersionId = Brand<number, 'TemplateVersionId'>;
export const TemplateVersionId = createBranded<TemplateVersionId>();
